import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Chrome } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_videogist-3/artifacts/809w15is_summbee%20logo_just%20bee.png";
const AUTH_URL = process.env.REACT_APP_AUTH_URL || "https://auth.emergentagent.com/";

function LoginPage() {
  const navigate = useNavigate();
  
  const handleGoogleSignIn = () => {
    const redirectUrl = `${window.location.origin}/dashboard`;
    window.location.href = `${AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  
  return (
    <div className="login-page">
      <nav className="navbar">
        <div className="nav-content">
          <div className="nav-logo" onClick={() => navigate("/")} style={{cursor: "pointer"}}>
            <img src={LOGO_URL} alt="SummBee" className="logo-image" />
            <span>SummBee</span>
          </div>
          <div className="nav-links">
            <button onClick={() => navigate("/")} className="nav-link" data-testid="back-to-home-link">
              ← Back to Home
            </button>
          </div>
        </div>
      </nav>
      
      <div className="login-container">
        <div className="login-content">
          <div className="login-hero">
            <img src={LOGO_URL} alt="SummBee" className="login-logo" />
            <h1 className="login-title">Welcome to SummBee</h1>
            <p className="login-subtitle">
              Professional knowledge management at scale
            </p>
          </div>
          
          <Card className="login-card" data-testid="login-card">
            <CardHeader>
              <CardTitle>Sign In</CardTitle>
              <CardDescription>
                Access your intelligence extraction platform
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button 
                onClick={handleGoogleSignIn}
                className="google-signin-button"
                data-testid="google-signin-button"
              >
                <Chrome className="button-icon" />
                Continue with Google
              </Button>
              
              <div className="login-benefits">
                <div className="benefit-item">
                  <div className="benefit-dot"></div>
                  <span>5 free Pro-tier extractions</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-dot"></div>
                  <span>1000+ platform support</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-dot"></div>
                  <span>Enterprise-grade security</span>
                </div>
              </div>
              
              <p className="login-terms">
                By signing in, you agree to our Terms of Service and Privacy Policy
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
